<template>
  <div class="dea-card-event-basic" @click="openEvent(event.event_url)">
    <Badge :class="event.bgMod">{{ event.type_label }}</Badge>
    <div class="dea-card-event-basic__title dea-heading--medium__m">{{ event.title }}</div>
    <div v-if="event.day && event.start_date_fmt" class="dea-heading--regular__ms">
      {{ event.day }}, {{ event.start_date_fmt }}
    </div>
    <div v-else-if="event.day" class="dea-heading--regular__ms">{{ event.day }}</div>
  </div>
</template>

<script>
import Badge from "@/components/elements/Badge";

export default {
  name: "CardEventBasic",
  components: { Badge },
  props: {
    event: {
      type: Object,
      required: true,
    },
    useRouter: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    openEvent(url) {
      if (this.useRouter) {
        this.$router.push({ name: "events" });
      } else {
        window.open(url);
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.dea-card-event-basic {
  align-items: flex-start;
  border: $border-light $dea-color-grey-medium-light;
  border-radius: $border-radius-medium;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 200px;
  padding: $space-small;

  &__title {
    height: 100%;
    margin-top: $space-small;
  }
}
</style>
